import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiquidFilterRotaryDrumOrDiscScraper = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 55,
	height: 100,
	viewBox: "0 0 55.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 50,
			height: 100,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 6.0 31.5 A 22.0 22.0 0.0 0 1 30.0 31.5 M 55.0 65.0 L 33.0 65.0 L 33.0 50.0 L 47.0 65.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 80.0 L 50.0 80.0 M 0.0 20.0 L 50.0 20.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 18,
			cy: 50,
			rx: 15,
			ry: 15,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		})
	]
});
export default SvgLiquidFilterRotaryDrumOrDiscScraper;
